import React from "react";

import { LibraryNavigationSidebar } from "js/editor/PresentationLibrary/LibraryNavigationSidebar";
import {
    LibraryNavigationView,
} from "js/editor/PresentationLibrary/libraryNavigationItems";
import {
    UIPaneSideBar,
    UIPaneWithSideBar,
} from "js/react/components/UiComponents";

type LibraryPaneLayoutProps = {
    children: React.ReactNode;
    className?: string;
    libraryView: LibraryNavigationView;
    onResizeSidebar?: (width: number) => void;
    showNavigationSidebar?: boolean;
    sideBarWidth?: number;
    teamPane?: string;
};

type UIPaneWithSideBarProps = {
    children: React.ReactNode;
    className?: string;
};

type UIPaneSideBarProps = {
    children: React.ReactNode;
    onResize?: (width: number) => void;
    style?: React.CSSProperties;
};

const TypedUIPaneWithSideBar = UIPaneWithSideBar as React.ComponentType<UIPaneWithSideBarProps>;
const TypedUIPaneSideBar = UIPaneSideBar as React.ComponentType<UIPaneSideBarProps>;

export function LibraryPaneLayout({
    children,
    className = "",
    libraryView,
    onResizeSidebar,
    showNavigationSidebar = true,
    sideBarWidth,
    teamPane,
}: LibraryPaneLayoutProps) {
    if (!showNavigationSidebar || window.isZoomApp) {
        return children;
    }

    return (
        <TypedUIPaneWithSideBar className={className}>
            <TypedUIPaneSideBar
                style={{ width: sideBarWidth || 260 }}
                onResize={onResizeSidebar}
            >
                <LibraryNavigationSidebar
                    libraryView={libraryView}
                    teamPane={teamPane}
                />
            </TypedUIPaneSideBar>
            {children}
        </TypedUIPaneWithSideBar>
    );
}
